import _ from 'lodash';

export const getViewableList = (scrolled, viewListData, sortProp, sortReverse, sortByPositionAfter, dataCount, sortByIndic, isSuperAdminDeveloper) => {

  let _vld = null

  const _viewListData = viewListData

  if (sortProp && sortProp.endsWith('Date')) {
    if (sortByPositionAfter) {
      _vld = _.orderBy(_viewListData, [(item) => (item[sortProp] ? new Date(item[sortProp]) : 0), 'position'], ['asc']);
    } else {
      _vld = _.orderBy(_viewListData, [(item) => (item[sortProp] ? new Date(item[sortProp]) : 0)], ['desc']);
    }
  } else {
    try {
      if (sortByIndic) {
        _vld = _.orderBy(_viewListData, [i => i[sortByIndic].toLowerCase(), i => i[sortProp].toLowerCase()]);
      } else {
        if (sortProp && sortProp.endsWith('UTC')) {
          if (sortByPositionAfter) {
            _vld = _.orderBy(_viewListData, [i => new Date(i[sortProp]), 'position'], ['asc']);
          } else {
            _vld = _.orderBy(_viewListData, [i => new Date(i[sortProp])]);
          }
        } else {
          if (sortByPositionAfter) {
            _vld = _.orderBy(_viewListData, [i => i[sortProp].toLowerCase(), 'position']);
          } else {
            switch (sortProp) {
              case 'lastName':
                _vld = _.orderBy(
                  _viewListData,
                  [
                    item => (item['lastName'] ? item['lastName'].toLowerCase() : ''),
                    item => (item['firstName'] ? item['firstName'].toLowerCase() : '')
                  ],
                  ['asc', 'asc'] // Sorting order for each criterion
                );

                break;
              default:
                _vld = _.orderBy(_viewListData, [i => i[sortProp].toLowerCase()]);
            }
          }
        }
      }
    } catch (error) {
      _vld = _.sortBy(_viewListData, sortProp)
    }
  }

  if (scrolled) {
    const nvld = []
    _vld.slice(0, dataCount).forEach((vld) => {
      nvld.push(vld);
    });
    return nvld
  } else {
    if (sortReverse) { _vld = _.reverse(_vld) }
    return _vld
  }
}